export const CampaignRoute = {
  CAMPAIGNS: 'campaigns',
};

export const CampaignPathName = {
  CAMPAIGNS: 'campaigns',
};

export const CampaignServiceDisplayName = {
  TAP_ORDERS: i18n.$t('TapOrders'),
};

export const CampaignServiceId = {
  TAP_ORDERS: '299',
};

export const MAX_CAMPAIGNS_ON_EXPORT = 10000000; // 10 Million
